// App.js
// @flow
import * as React from 'react';
import {Helmet} from "react-helmet";
import { observer } from 'mobx-react'

import {IntlProvider, addLocaleData} from 'react-intl';
import { locale } from './Locale.js';

//OLD hardwired
//import es from 'react-intl/locale-data/es';
//addLocaleData([...es]);

//NEW -- XXX and do the same with Locale.js
//from: https://stackoverflow.com/questions/41282510/how-to-add-locale-data-dynamically-using-react-intl https://github.com/yahoo/react-intl/issues/777
//addLocaleData(require(`react-intl/locale-data/${GLOBAL_locale}`));

const GLOBAL_locale = locale; // from Locale.js

import es from 'react-intl/locale-data/es';
import en from 'react-intl/locale-data/en';
if (GLOBAL_locale === 'es') {
  addLocaleData([...es]);
} else {
  addLocaleData([...en]);
}


import { HashRouter, Route, Redirect } from 'react-router-dom';
import { withRouter } from 'react-router';

//import Cookies from 'universal-cookie'; // PREFIX: unicoo_
//const unicoo_cookies = new Cookies();

// Top level components
import Header from './components/Header.js';
import NavigationButtons from './components/NavigationButtons.js';
import NavigationStructure from './NavigationStructure.js';

// Pages
import HomePage from './pages/HomePage.js';
import LoginPage from './pages/LoginPage.js';
import ConsentPage from './pages/ConsentPage.js';
import LanguagePage from './pages/LanguagePage.js';
import AvatarPage from './pages/AvatarPage.js';
import AboutPage from './pages/AboutPage.js';
import SummaryPage from './pages/SummaryPage.js';
import ChemicalPage from './pages/ChemicalPage.js';
import CommunityActionPage from './pages/CommunityActionPage.js';
import SurveyPage from './pages/SurveyPage.js';
import ConclusionPage from './pages/ConclusionPage.js';

import OverallStudyResultsPage from './pages/OverallStudyResultsPage.js';
import HealthAndChemicalsPage from './pages/HealthAndChemicalsPage.js';
import GraphReadingTutorialPage from './pages/GraphReadingTutorialPage.js';

import FAQPage from './pages/FAQPage.js';
import PrintPage from './pages/PrintPage.js';
import AppendixPage from './pages/AppendixPage.js';

import { state } from './State';

import './css/App.css';
import helpers from './util/helpers';
import { Api } from './Api.js';



if(!global.Intl) {
  global.Intl = require('intl');
}

let prevPage1;
let prevPage2;
const StateRoute = ({ Component, ...rest }) => (
  <Route {...rest} render={props => (
    <Component appState={state} {...props} prevPage={prevPage2}/>
  )}/>
)

type Props = {
  children?: React.Node
};

const App = withRouter(class App extends React.Component<Props> {

  componentWillMount() {

    var get_access_code = helpers.findGetParameter('access_code');
    var thepromise;
    if (get_access_code && (state.data.length === 0))
    {
      // console.log("path1");
      thepromise = Api.authenticateshell(get_access_code, state);
      window.thepromise = thepromise;
    }
    else
    {
      // console.log("path2");
      thepromise = new Promise(function(resolve, reject) { resolve(0) });
    }

    window.thepromise = thepromise;
    let current = this;

    thepromise.then(function(result) {
      // console.log("get_access_code ="+get_access_code + " pathname="+current.props.location.pathname);
      if(current.props.location.pathname !== '/' && current.props.location.pathname !== '/login')
      {

        if(state.data.length === 0) {
          state.loadMeasurements().catch((error) => {
            if (!get_access_code) current.props.history.push("/login");
          });
        }

        if(state.headlines.length === 0) {
          state.loadHeadlines().catch((error) => {
            if (!get_access_code) current.props.history.push("/login");
          });
        }

      } // end checkMeasurements and Headlines

    }); // end thepromise.then

  } // end-componentWillMount


  render() {
    // get the previous page, for use on the avatar page
    prevPage2 = prevPage1
    prevPage1 = this.props.location.pathname;

    // if not logged in, don't allow access to the rest of the site
    let loggedOutPages = ["/", "/login"]
    if (!loggedOutPages.includes(this.props.location.pathname)) {
      // if the path is a page when you're supposed to be logged in
      if (!state.loggedIn) {
        // but if you're not logged in,
        // redirect to loging
        return <Redirect to={"/login"} />
      }
    }

    let dynamic_inline_css = "";

    // don't log the main page and login page because a user hasn't logged in yet
    if (this.props.location.pathname != "/" && this.props.location.pathname != "/login") {
      helpers.eventLog("App.render() - " + this.props.location.pathname);
    }

    if (helpers.findGetParameter('print'))
    {
      // inline for print #6 -- hide many of the buttons since not needed in print
      dynamic_inline_css = ".faq-button, .button, .buttons, .feedback, .printhide {display:none;}  .printhide_v {visibility:hidden;}";

    }

    return (
      <div className='wrapper'>
        <style>{dynamic_inline_css}</style>
        <div className='content'>
          <div className='content-inside'>
            <Header appState={state} />
            {this.props.children}
          </div>
        </div>
        <NavigationButtons appState={state} />
      </div>
    );
  } // end-render
});

class AppRouter extends React.Component<RouterProps> {
  render() {
    return (
      <IntlProvider locale={locale} key={locale} messages={state.messages}>
        <HashRouter onUpdate={() => window.scrollTo(0, 0)} basename={NavigationStructure.rootPath}>
          <App>
            <Helmet>
              <title>{state.messages['app.home.title']}</title>
            </Helmet>
            <StateRoute exact path={`/`} Component={HomePage} />
            <StateRoute path={`/login`} Component={LoginPage} />
            <StateRoute path={`/consent`} Component={ConsentPage} />
            <StateRoute path={`/avatar`} Component={AvatarPage} />
            <StateRoute path={`/langset`} Component={LanguagePage} />
            <StateRoute path={`/about`} Component={AboutPage} />
            <StateRoute path={`/health`} Component={HealthAndChemicalsPage} />
            <StateRoute path={`/readinggraphs`} Component={GraphReadingTutorialPage} />
            <StateRoute path={`/summary`} Component={SummaryPage} />
            <StateRoute path={`/water_summary`} Component={SummaryPage} />
            <StateRoute path={`/overallstudyresults`} Component={OverallStudyResultsPage} />

            <StateRoute exact path={`/chemicals/:chemical`} Component={ChemicalPage} />
            <StateRoute exact path={`/community_action`} Component={CommunityActionPage} />
            <StateRoute path={`/survey`} Component={SurveyPage} />
            <StateRoute path={`/conclusion`} Component={ConclusionPage} />

              <StateRoute path={`/faqpage`} Component={FAQPage} />
              <StateRoute path={`/appendix`} Component={AppendixPage} />
              <StateRoute path={`/printpage`} Component={PrintPage} />

          </App>
        </HashRouter>
      </IntlProvider>
    );
}
}

export default observer(AppRouter);



// WEBPACK FOOTER //
// ./src/App.js